module.exports = __webpack_public_path__ + "static/img/sz.d266727d.svg";